import React from 'react'
import ModalPopup from '../common/ModalPopup'
import { locationRoute } from '../../routes/routes'
import { normalizeDeliveryErrorMessage } from '../../util/errorUtils'
import { formatUrl } from '../../util/formatUtils'
import { Button } from '@foodsby/nutrient'

const navigate = linkRoute => {
  window.location.href = linkRoute
}

export const ValidationMessage = ({ messageText, buttonText, linkRoute }) => (
  <div className="invalid-order row center-xs">
    <div className="col-xs-12">
      <h2 className="primary">{messageText}</h2>
      <Button onClick={() => navigate(linkRoute)}>{buttonText}</Button>
    </div>
  </div>
)

export const ValidationModal = ({ serverMessage, locationId }) => (
  <ModalPopup showCancel={false}>
    <ValidationMessage
      buttonText="Select Another Delivery"
      linkRoute={formatUrl(locationRoute.path, {
        locationId,
      })}
      messageText={normalizeDeliveryErrorMessage(serverMessage)}
    />
  </ModalPopup>
)

export default ValidationModal
